import { useState } from 'react';
import {
  Box,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  CircularProgress,
  TablePagination,
} from '@mui/material';

interface JobResultCommentsProps {
  comments: any[];
  status: string;
}

export default function JobResultComments({ comments, status }: JobResultCommentsProps) {
  const [page, setPage] = useState(0);
  const rowsPerPage = 10;

  const handleChangePage = (event: unknown, newPage: number) => {
    setPage(newPage);
  };

  const paginatedComments = comments.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);

  return (
    <>
      {/* Mobil nézet */}
      <Box sx={{ display: { xs: 'block', md: 'none' } }}>
        {paginatedComments.map((comment) => (
          <Paper key={comment.id} sx={{ mb: 2, p: 2 }}>
            <Typography variant="body1" sx={{ wordBreak: 'break-word' }}>
              {comment.comment}
            </Typography>
            <Typography variant="subtitle2" color="text.secondary" sx={{ mt: 1 }}>
              Sentiment: {comment.score}
            </Typography>
          </Paper>
        ))}
        {(status === 'Pending' || status === 'Processing') && (
          <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
            Frissítés...
          </Typography>
        )}
        <TablePagination
          component="div"
          count={comments.length}
          page={page}
          onPageChange={handleChangePage}
          rowsPerPage={rowsPerPage}
          rowsPerPageOptions={[]}
        />
      </Box>

      {/* Asztali nézet */}
      <TableContainer component={Paper} sx={{ display: { xs: 'none', md: 'block' }, mt: 2 }}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Komment</TableCell>
              <TableCell>Sentiment pontszám</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {paginatedComments.map((comment) => (
              <TableRow key={comment.id}>
                <TableCell sx={{ wordBreak: 'break-word' }}>{comment.comment}</TableCell>
                <TableCell>{comment.score}</TableCell>
              </TableRow>
            ))}
            {(status === 'Pending' || status === 'Processing') && (
              <TableRow>
                <TableCell colSpan={2} align="center">
                  <CircularProgress size={24} />
                  <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
                    Frissítés...
                  </Typography>
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
        <TablePagination
          component="div"
          count={comments.length}
          page={page}
          onPageChange={handleChangePage}
          rowsPerPage={rowsPerPage}
          rowsPerPageOptions={[]}
        />
      </TableContainer>

      {/* Nincsenek kommentek */}
      {comments.length === 0 && status === 'Completed' && (
        <Typography variant="body1" sx={{ mt: 2 }}>
          Nincsenek kommentek
        </Typography>
      )}
    </>
  );
}
